import {formatSimmsDateTime} from "../../../../components/commonmethod/CommonMethod";

export function getNestedValue(obj, path) {
    if (path == null || path === "") return "";
    const value = String(path)
        .split(".")
        .reduce((acc, part) => (acc && acc[part]), obj);
    return value ?? "";
}

function formatDateValue(value) {
    return formatSimmsDateTime(value);
}

function formatScalar(value) {
    if (value == null || value === "") return "";
    if (typeof value === "object") {
        return value.name ?? value.title ?? value.label ?? "";
    }
    return String(value);
}

export function formatLinkedCellText(row, col) {
    const field = col.key;
    if (field?.includes("|")) {
        const parts = field.split("|");
        return parts
            .map((part, index) => {
                const label = col.label?.[index] ?? "";
                const raw = getNestedValue(row, part);
                const text =
                    typeof raw === "string" && /^\d{4}-\d{2}-\d{2}/.test(raw)
                        ? formatDateValue(raw)
                        : formatScalar(raw);
                return text ? `${label}${text}` : "";
            })
            .filter(Boolean)
            .join(" · ");
    }

    const raw = getNestedValue(row, field);
    if (typeof raw === "string" && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
        return formatDateValue(raw);
    }
    return formatScalar(raw);
}

export function formatLinkedHistoryAuthor(row, col) {
    if (col) {
        const text = formatLinkedCellText(row, col);
        if (text) return text;
    }
    const by = row?.createdBy ?? row?.updatedBy;
    if (by == null) return "";
    if (typeof by === "string") return by;
    return by.name ?? by.userName ?? by.loginId ?? "";
}

export function formatLinkedHistoryDate(row, col) {
    const raw = getNestedValue(row, col?.key ?? "createdAt");
    return formatSimmsDateTime(raw);
}
